import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useDeleteTargetMutation, useTargetDetailsQuery } from 'api';
import { GoBackButtonWithTitle, NewConfirmDialog, PageWrapper, Spinner } from 'components';
import { useModal } from 'hooks';

import { EditTargetForm } from '../../components';
import { FlexW } from './styled';

export function EditTargetPage(): ReactElement {
  const { t } = useTranslation();
  const { targetId = '' } = useParams<string>();
  const { isLoading, data } = useTargetDetailsQuery(targetId);
  const { deleteTargetMutation } = useDeleteTargetMutation();
  const { handleOpenModal, handleCloseModal, isOpen } = useModal();

  async function handleDeleteTarget() {
    await deleteTargetMutation({ targetId });
  }

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <PageWrapper>
      <GoBackButtonWithTitle
        title={t('kpi.targetForm.editTitle')}
        containerSx={{ marginTop: '16px' }}
      />
      <FlexW>
        {data?.data && (
          <EditTargetForm
            targetId={targetId}
            title={data?.data.title}
            value={data?.data.value}
            target={data?.data.target}
            type={data?.data.type}
            handleOpenModal={handleOpenModal}
          />
        )}
      </FlexW>

      <NewConfirmDialog
        title={t('kpi.targetForm.removeModal.title', { targetTitle: data?.data.title })}
        subTitle={t('kpi.targetForm.removeModal.subtitle')}
        open={isOpen}
        onConfirm={handleDeleteTarget}
        onClose={handleCloseModal}
        submitLabel={t('kpi.targetForm.removeModal.successButton')}
        cancelLabel={t('kpi.targetForm.removeModal.cancelButton')}
      />
    </PageWrapper>
  );
}
